import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { message } from 'antd'
import styles from './index.module.scss'
import MainContext from '../../stores/stores'
import llq1Png from '../../assets/img/llq1.png'
import llq2Png from '../../assets/img/llq2.png'
import { useIntl } from 'react-intl'

const Footer: React.FC<any> = (props) => {
  const intl = useIntl()
  let lang = localStorage.getItem('lang') || 'zh'
  const navigate = useNavigate()
  const { commonStore, setCommonStore } = useContext(MainContext)
  const { userInfo, pageType, isWomala, webData, colorPrimary, logo, fontColorPrimary  } = commonStore

  useEffect(() => {
    setTimeout(() => {
      props.onReady?.()
    },100)
  },[pageType])

  const goto = (url: string) => {
    if(url) {
      window.open(url, "_blank")
    }
  }
  const toHome = () => {
    navigate('/home')
  }
  const toMoreLink = (item: any) => {
    if(item.need_login && (!localStorage.getItem('token') || localStorage.getItem("tourist_user"))) {
      message.warning(intl.formatMessage({ id: "请先登录" }))
      navigate('/login')
      return false
    }
    let url = item.url
    navigate(url)
  }
  const cexport = () => {
    const origin = window.location.origin || ''
    const allowed = [
      'kangpower.maiqipei.com',
      'www.kangpower.com'
    ]
    const originMatches = allowed.some((s) => origin.includes(s))
    if (originMatches) return true
    if (origin.includes('webtest.maiqipei.com') || origin.includes('300')) return true
    return false
  }
  let otherPage  = pageType === '3' || isWomala ? true : false
  return (
    <>
      {
        pageType === '4' || pageType === '5' || pageType === '6' || pageType === '7' || pageType === '9' ? <div 
          id="footer"
          className={styles['footer2'] + ' ' + `${pageType === '8' ? styles['footer-mqp'] : ''}`} 
          style={{ backgroundColor: otherPage ? '#EDEDED' : colorPrimary, color: otherPage ? '#000000' : (fontColorPrimary ? fontColorPrimary : '#ffffff') }}
        >
          <div className={styles['footer-wrap']} style={{width: pageType === '7' || pageType === '9' ? 1200 : '100%'}}>
            <div className={styles['footer-lf']}>
              <div className={styles['footer-logo-wrap']}>
                <img src={logo} className={styles['footer-logo']} alt="" onClick={toHome} />
                {
                  webData.moreLink && webData.moreLink.length ? null : <div className={styles['vertical']}></div>
                }
              </div>
            </div>
            <div className={styles['footer-rt']}>
              {
                webData.moreLink && webData.moreLink.length ? <div className={styles['more-links']}>
                  {
                    webData.moreLink.map((items: any, index: number) => {
                      return (
                        <div className={styles['more-link']} key={index} style={{maxWidth: (100/webData.length).toFixed(0) + '%'}}>
                          {
                            items.title ? <div className={styles['link-title']} style={{textAlign: webData.moreLink.length > 1 ? (items.align ? items.align : 'left') : 'left'}}><pre>{items.title}</pre></div> : null
                          }
                          {
                            items.links && items.links.length ? <div className={webData.moreLink.length === 1 ? styles['link-list'] + ' flex-s-c flex-wrap' : styles['link-list']}>
                              {
                                items.links.map((item: any, n: number) => {
                                  return (
                                    <div 
                                      className={styles['link-item']} 
                                      key={n}
                                      style={{width: webData.moreLink.length === 1 ? '33%' : '100%', textAlign: webData.moreLink.length > 1 ? (items.align ? items.align : 'left') : 'left'}} 
                                      onClick={() => toMoreLink(item)}
                                    >
                                      {item.name}
                                    </div>
                                  )
                                })
                              }
                            </div> : null
                          }
                        </div>
                      )
                    })
                  }
                </div> : null
              }
              {/* {
                webData.moreLink && webData.moreLink.length ? <div className={styles['more-links'] + ' mb5'}>
                  {
                    webData.moreLink.map((items: any, index: number) => {
                      return (
                        <div className={styles['more-link']} key={index}>
                          {
                            items.links && items.links.length ? <div className={webData.moreLink.length === 1 ? styles['link-list'] + ' flex-s-c flex-wrap' : styles['link-list']}>
                              {
                                items.links.map((item: any, n: number) => {
                                  return (
                                    <div 
                                      className={styles['link-item']} 
                                      key={n}
                                      style={{width: webData.moreLink.length === 1 ? '33%' : '100%'}} 
                                      onClick={() => toMoreLink(item)}
                                    >
                                      {item.name}
                                    </div>
                                  )
                                })
                              }
                            </div> : null
                          }
                        </div>
                      )
                    })
                  }
                </div> : null
              } */}
              <div className={styles['footer-company']}>
                <div className={styles['footer-rt-l']}>
                  {
                    webData.phone ? <div className={styles['footer-item']} style={{marginRight: lang === 'ara' ? 0 : 40, marginLeft: lang === 'ara' ? 40 : 0, height: pageType === '7' ? 'unset' : '55px'}}>
                      {
                        pageType !== '7' ? <div>{intl.formatMessage({id: '咨询热线'})}</div> : null
                      }
                      <div>
                        <i className="iconfont icon-a-24gf-telephone1 mr5" />
                        {webData.phone}
                      </div>
                    </div> : null
                  }
                  {
                    webData.email ? <div className={styles['footer-item']} style={{height: pageType === '7' ? 'unset' : '55px'}}>
                      {
                        pageType !== '7' ? <div>{intl.formatMessage({id: '企业邮箱'})}</div> : null
                      }
                      <div>
                        <i className="iconfont icon-a-youxiang11 mr5" />
                        {webData.email} 
                      </div>
                    </div> : null
                  }
                </div>
                {
                  pageType === '7' ? <div className={styles['footer-item3']}>
                    <div style={{ cursor: 'pointer'  }}  onClick={() => goto('https://www.maiqipei.com/')}>{intl.formatMessage({id: '此网站由零零汽提供技术支持'})}</div>
                    <span className="ml10 mr10">|</span>
                    <div style={{ cursor: 'pointer'  }} onClick={() => goto('https://beian.miit.gov.cn')}>{webData.filings_no}</div>
                  </div> : <div className={styles['footer-item2']}>
                    <div style={{ cursor: 'pointer'  }}  onClick={() => goto('https://www.maiqipei.com/')}>{intl.formatMessage({id: '此网站由零零汽提供技术支持'})}</div>
                    <div>
                      <div className="center  flex-c-c" style={{ opacity: .8 }}>
                        <span>{webData.filings}</span>
                        <span style={{ borderBottom: '1px solid #878787', cursor: 'pointer'  }} onClick={() => goto('https://beian.miit.gov.cn')}>{webData.filings_no}</span>
                      </div>
                    </div>
                  </div>
                }
                
              </div>
              
            </div>
          </div>
          {/* {
            cexport() ? <div className='center'>
              Website đang trong thời gian trong thời gian khai báo với Bộ Công Thương
            </div> : null
          } */}
          
        </div> : pageType === '8' ? <div 
          id="footer"
          className={styles['footer2'] + ' ' + `${pageType === '8' ? styles['footer-mqp'] : ''}`} 
          style={{ backgroundColor: otherPage ? '#EDEDED' : colorPrimary, color: otherPage ? '#000000' : (fontColorPrimary ? fontColorPrimary : '#ffffff') }}
        >
          <div className={styles['footer-wrap']}>
            <div className={styles['footer-lf']} style={{ borderRight: '1.5px solid rgba(153, 153, 153, 0.2)' }}>
              <div className={styles['footer-logo-wrap']}>
                <img src={logo} className={styles['footer-logo']} alt="" onClick={toHome} />
                {
                  webData.moreLink && webData.moreLink.length ? null : <div className={styles['vertical']}></div>
                }
              </div>
            </div>
            <div className={styles['footer-rt']} style={{ width: 'calc(100% - 160px)' }}>
              <div className={styles['footer-company']}>
                <div className={styles['footer-rt-l']}>
                  <img src="https://xqpcdns.007vin.com/1772451384809.fMrdwHTaL 3.png" style={{ width: 60, height: 60, marginRight: 10 }} />
                  {
                    webData.phone ? <div className={styles['footer-item']} style={{marginRight: lang === 'ara' ? 0 : 40, marginLeft: lang === 'ara' ? 40 : 0, height: pageType === '7' ? 'unset' : '55px'}}>
                      {
                        pageType !== '7' ? <div>{intl.formatMessage({id: '咨询热线'})}</div> : null
                      }
                      <div>
                        <i className="iconfont icon-a-24gf-telephone1 mr5" />
                        {webData.phone}
                      </div>
                    </div> : null
                  }
                  {
                    webData.email ? <div className={styles['footer-item']} style={{height: pageType === '7' ? 'unset' : '55px'}}>
                      {
                        pageType !== '7' ? <div>{intl.formatMessage({id: '企业邮箱'})}</div> : null
                      }
                      <div>
                        <i className="iconfont icon-a-youxiang11 mr5" />
                        {webData.email} 
                      </div>
                    </div> : null
                  }
                </div>
                {
                  pageType === '7' ? <div className={styles['footer-item3']}>
                    <div style={{ cursor: 'pointer'  }}  onClick={() => goto('https://www.maiqipei.com/')}>{intl.formatMessage({id: '此网站由零零汽提供技术支持'})}</div>
                    <span className="ml10 mr10">|</span>
                    <div style={{ cursor: 'pointer'  }} onClick={() => goto('https://beian.miit.gov.cn')}>{webData.filings_no}</div>
                  </div> : <div className={styles['footer-item2']}>
                    <div style={{ cursor: 'pointer'  }}  onClick={() => goto('https://www.maiqipei.com/')}>{intl.formatMessage({id: '此网站由零零汽提供技术支持'})}</div>
                    <div>
                      <div className="center  flex-c-c" style={{ opacity: .8 }}>
                        <span>{webData.filings}</span>
                        <span style={{ borderBottom: '1px solid #878787', cursor: 'pointer'  }} onClick={() => goto('https://beian.miit.gov.cn')}>{webData.filings_no}</span>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div> : <div 
          id="footer"
          className={styles['footer']} 
          style={{ backgroundColor: otherPage ? '#EDEDED' : colorPrimary, color: otherPage ? '#000000' : (fontColorPrimary ? fontColorPrimary : '#ffffff') }}
          // style={{ backgroundColor: isWomala  ? '#EDEDED' : '#434343', color: isWomala ? '#000000' : '#ffffff' }}
        >
          {
            webData.moreLink && webData.moreLink.length ? <div className={styles['footer-link']}>
              <div className={styles['more-links']}>
                {
                  webData.moreLink.map((items: any, index: number) => {
                    return (
                      <div className={styles['more-link']} key={index}>
                        {
                          items.title ? <div className={styles['link-title']}>{items.title}</div> : null
                        }
                        
                      </div>
                    )
                  })
                }
              </div>
              <div className={styles['more-links'] + ' mb5'}>
                {
                  webData.moreLink.map((items: any, index: number) => {
                    return (
                      <div className={styles['more-link']} key={index}>
                        {
                          items.links && items.links.length ? <div className={webData.moreLink.length === 1 ? styles['link-list'] + ' flex-s-c flex-wrap' : styles['link-list']}>
                            {
                              items.links.map((item: any, n: number) => {
                                return (
                                  <div 
                                    className={styles['link-item']} 
                                    key={n}
                                    style={{width: webData.moreLink.length === 1 ? '33%' : '100%'}} 
                                    onClick={() => toMoreLink(item)}
                                  >
                                    {item.name}
                                  </div>
                                )
                              })
                            }
                          </div> : null
                        }
                      </div>
                    )
                  })
                }
              </div>
            </div> : null
          }
          <div className={styles['footer-company2']}>
            {
              webData.img ? <div className={styles['logo-img']} onClick={toHome}>
                <img src={webData.img}/>
              </div> : null
            }
            {
              webData.phone ? <p className="center flex-c-c">
                <i className="iconfont icon-a-24gf-telephone1 mr5" />
                {webData.phone}
              </p> : null
            }
            {
              webData.email ? <p className="center  flex-c-c">
                <i className="iconfont icon-a-youxiang11 mr5" />
                {webData.email} 
              </p> : null
            }
            <p className="center  flex-c-c" style={{ opacity: .8 }}>
              <span>{webData.filings}</span>
              <span style={{ borderBottom: '1px solid #878787', cursor: 'pointer'  }} onClick={() => goto('https://beian.miit.gov.cn')}>{webData.filings_no}</span>
            </p>
            <p className="center flex-c-c" style={{ fontSize: 12 }}>
              {
                otherPage ? <img className="mr5" src={llq1Png} alt="" /> : <img className="mr5" src={llq2Png} alt="" />
              }
              <span
                onClick={() => goto('https://www.007vin.com/')} 
                className="pointer" style={{ display: 'inline-block', borderBottom: '1px solid #878787', opacity: .8 }}>
                {intl.formatMessage({ id: '零零汽提供技术支持' })}
              </span>
            </p>
            {
              webData.qrcode ? <div className={styles['qrcode-img']}>
                <img src={webData.qrcode}/>
              </div> : null
            }
          </div>
          {
            cexport() ? <div className='center'>
              Website đang trong thời gian trong thời gian khai báo với Bộ Công Thương
            </div> : null
          }
          
        </div>
      }
    </>
    
  )
}

export default Footer